export default "__VITE_ASSET__nN7N4Yf7__"